import React from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { TonConnectUIProvider } from "@tonconnect/ui-react";
import { AppRoot } from "@telegram-apps/telegram-ui";
import { TON_CONNECT_MANIFEST_URL } from "./configs/config";
import I18nProvider from "./utils/i18n/I18nProvider";
import { AppWithLoadingState } from "./components/App/AppWithLoadingState";
import { ErrorProvider } from "./utils/error";
import { ModalManagerProvider } from "./utils/modal/ModalManager";
import { ServicesProvider } from "./services/ServicesProvider";
import DesktopLanding from "./components/DesktopLanding/DesktopLanding";
import { MainMenuPage } from "./pages/MainMenuPage";
import { ShopPage } from "./pages/ShopPage";
import { InvitePage } from "./pages/InvitePage";
import { LeaderboardPage } from "./pages/LeaderboardPage";
import { TasksPage } from "./pages/TasksPage";
import { SettingsPage } from "./pages/SettingsPage";
import { MagicBooksPage } from "./pages/MagicBooksPage";
import { ManaPage } from "./pages/ManaPage";
import isDesktop from "./utils/isDesktop";
import { SimpleGame } from "./components/SimpleGame/SimpleGame";

interface AppProps {
  platform?: string;
}

function AppRoutes() {
  const navigate = useNavigate();

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/menu" replace />} />
      <Route path="/menu" element={<MainMenuPage />} />
      <Route path="/shop" element={<ShopPage />} />
      <Route path="/invite" element={<InvitePage />} />
      <Route path="/leaderboard" element={<LeaderboardPage />} />
      <Route path="/tasks" element={<TasksPage />} />
      <Route path="/mana" element={<ManaPage />} />
      <Route path="/settings" element={<SettingsPage />} />
      <Route path="/magic-books" element={<MagicBooksPage />} />
      <Route path="/game" element={<SimpleGame />} />
      <Route path="*" element={<Navigate to="/menu" replace />} />
    </Routes>
  );
}

export function App({ platform }: AppProps) {
  if (isDesktop()) {
    return <DesktopLanding />;
  }

  return (
    <AppRoot className="app-root">
      <TonConnectUIProvider manifestUrl={TON_CONNECT_MANIFEST_URL}>
        <I18nProvider>
          <ServicesProvider>
            <AppWithLoadingState>
              <ErrorProvider>
                <ModalManagerProvider>
                  <AppRoutes />
                </ModalManagerProvider>
              </ErrorProvider>
            </AppWithLoadingState>
          </ServicesProvider>
        </I18nProvider>
      </TonConnectUIProvider>
    </AppRoot>
  );
}
